import { Controller } from "@hotwired/stimulus"

// Drives the timecard action-confirmation dialog. An action button opens step 1
// (a custom question + confirm label, passed via Stimulus action params). A
// button that passes a `url` param POSTs that endpoint on confirm (ids[] = the
// card id; Turbo handles the redirect) — that's how Void is wired. A button
// without a `url` falls back to the legacy "not implemented yet" notice
// (send-to-MSF is still not wired up).
export default class extends Controller {
  static targets = ["dialog", "message", "confirmLabel", "confirmStep", "doneStep"]

  open(event) {
    this.messageTarget.textContent = event.params.message
    this.confirmLabelTarget.textContent = event.params.label
    this.url = event.params.url || null
    this.recordId = event.params.id
    this.confirmStepTarget.hidden = false
    this.doneStepTarget.hidden = true
    this.dialogTarget.hidden = false
  }

  // Step 1 → either POST the wired action, or show the "not implemented" notice.
  confirm() {
    if (this.url) {
      this.submit()
      return
    }
    this.confirmStepTarget.hidden = true
    this.doneStepTarget.hidden = false
  }

  submit() {
    const form = document.createElement("form")
    form.method = "post"
    form.action = this.url
    form.style.display = "none"

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (token) form.appendChild(this.hidden("authenticity_token", token))
    if (this.recordId !== undefined && this.recordId !== null) {
      form.appendChild(this.hidden("ids[]", this.recordId))
    }

    document.body.appendChild(form)
    if (form.requestSubmit) form.requestSubmit()
    else form.submit()
  }

  hidden(name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    return input
  }

  close() {
    this.dialogTarget.hidden = true
  }

  // Close only when the centering wrapper itself is clicked (outside the card),
  // not the dialog body.
  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }
}
